import { AxiosAdapter } from '../../_config/v2/adapters/axios/axios.adapter';
import { Http } from '../../_config/v2/adapters/axios/axios.protocols';
import { Enviroment } from '../../_config/constants/enviroment-v2.constant';

export class Service {
	async getFooter() {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.API_PHARMACY}/config-footer/${Enviroment.COUNTRY}/${Enviroment.ROOT_PHARMACY}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}

	async getPharmacy() {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FUNCTION_MIGRATION_PHAROL}/pharmacy-locals/country/${Enviroment.COUNTRY}/pharmacy/${Enviroment.ROOT_PHARMACY}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}

	async getModulesByTemplate(template, platform, pharmacy) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FUNCTION_API_PHARMACY}/logo/get-modules-by-template/${template}/${platform}/${Enviroment.COUNTRY}/${pharmacy}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}
}
